/* pc-mega-menu.js: moved out of sections/pc-mega-menu.liquid inline script (Page Weight, Oct 2026). */
(function () {
  if (window.__pcMegaMenuJs) return;
  window.__pcMegaMenuJs = true;
  (function () {
    function init(root) {
      if (!root || root.getAttribute('data-pcn-ready')) return;
      root.setAttribute('data-pcn-ready', '1');
      var body = document.body;
      var header = document.querySelector('.section-header');

      /* ---------- mount into the theme header ---------- */
      var deskNav = root.querySelector('[data-pcn-desk-nav]');
      var slot = header && header.querySelector('.header__inline-menu');
      if (deskNav && slot) { slot.appendChild(deskNav); body.classList.add('pcn-desk-ready'); }
      var burger = root.querySelector('[data-pcn-burger]');
      var left = header && header.querySelector('.header__left-icons');
      if (burger && left) { left.insertBefore(burger, left.firstChild); body.classList.add('pcn-mob-ready'); }

      /* ---------- menu images: give them their real address only when that part of the menu opens ---------- */
      var per = parseInt(root.getAttribute('data-pcn-per'), 10) || 4, feeds = {};
      function getFeed(url) {
        if (!feeds[url]) feeds[url] = fetch(url + (url.indexOf('?') < 0 ? '?' : '&') + 'view=pcn-cards', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { delete feeds[url]; return ''; });
        return feeds[url];
      }
      function fillFeeds(el, show) {
        var lists = el.matches && el.matches('[data-pcn-feed]') ? [el] : Array.prototype.slice.call(el.querySelectorAll('[data-pcn-feed]'));
        lists.forEach(function (ul) {
          if (ul.getAttribute('data-pcn-filled')) { if (show) swapImgs(ul); return; }
          getFeed(ul.getAttribute('data-pcn-feed')).then(function (html) {
            if (!html || ul.getAttribute('data-pcn-filled')) return;
            ul.setAttribute('data-pcn-filled', '1');
            ul.innerHTML = html;
            Array.prototype.slice.call(ul.children, per).forEach(function (li) { ul.removeChild(li); });
            if (show || ul.getAttribute('data-pcn-show')) swapImgs(ul);
          });
          if (show) ul.setAttribute('data-pcn-show', '1');
        });
      }
      /* fetch the department rows once the page has finished loading, so the first hover is instant */
      function prefetch() {
        root.querySelectorAll('[data-pcn-group="all"] [data-pcn-feed]').forEach(function (ul) { fillFeeds(ul, false); });
      }
      function whenIdle() { (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(prefetch, { timeout: 4000 }); }
      if (document.readyState === 'complete') whenIdle(); else window.addEventListener('load', whenIdle);
      function hydrate(el) {
        if (!el || !el.querySelectorAll) return;
        fillFeeds(el, true);
        swapImgs(el);
      }
      function swapImgs(el) {
        el.querySelectorAll('img[data-pcn-src]').forEach(function (img) {
          var ss = img.getAttribute('data-pcn-srcset');
          if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-pcn-srcset'); }
          img.setAttribute('src', img.getAttribute('data-pcn-src')); img.removeAttribute('data-pcn-src');
        });
      }

      /* ---------- desktop panels ---------- */
      var tops = deskNav ? Array.prototype.slice.call(deskNav.querySelectorAll('[data-pcn-top]')) : [];
      var openIdx = null, closeT = null, openT = null;
      function headerBottom() {
        var h = header && (header.querySelector('header.header') || header);
        var b = h ? h.getBoundingClientRect().bottom : 0;
        return Math.max(0, Math.round(b));
      }
      function place() { root.style.setProperty('--pcn-top', headerBottom() + 'px'); }
      function panel(i) { return root.querySelector('[data-pcn-panel="' + i + '"]'); }
      function open(i) {
        clearTimeout(closeT);
        if (openIdx === i) return;
        if (openIdx !== null) { var old = panel(openIdx); if (old) old.classList.remove('is-open'); }
        place();
        var p = panel(i); if (!p) return;
        hydrate(p);
        p.classList.add('is-open');
        showGroup(p, 'all');
        root.classList.add('is-desk-open');
        tops.forEach(function (t) { t.setAttribute('aria-expanded', t.getAttribute('data-pcn-top') === String(i) ? 'true' : 'false'); });
        openIdx = i;
      }
      function showGroup(p, key) {
        var groups = p.querySelectorAll('[data-pcn-group]'); if (groups.length < 2) return;
        var target = p.querySelector('[data-pcn-group="' + key + '"]') || p.querySelector('[data-pcn-group="all"]');
        groups.forEach(function (g) { var on = g === target; if (on && g.hidden) { g.classList.remove('is-swap'); void g.offsetWidth; g.classList.add('is-swap'); } g.hidden = !on; g.classList.toggle('is-active', on); });
        p.querySelectorAll('[data-pcn-child]').forEach(function (a) { a.classList.toggle('is-hover', a.getAttribute('data-pcn-child') === key); });
      }
      root.querySelectorAll('[data-pcn-panel]').forEach(function (p) {
        p.querySelectorAll('[data-pcn-child]').forEach(function (a) {
          var k = a.getAttribute('data-pcn-child'), t;
          a.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { showGroup(p, k); }, 60); });
          a.addEventListener('mouseleave', function () { clearTimeout(t); });
          a.addEventListener('focus', function () { showGroup(p, k); });
        });
      });
      function close() {
        clearTimeout(openT);
        if (openIdx === null) return;
        var p = panel(openIdx); if (p) p.classList.remove('is-open');
        root.classList.remove('is-desk-open');
        tops.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        openIdx = null;
      }
      function closeSoon() { clearTimeout(closeT); closeT = setTimeout(close, 160); }
      var touchy = window.matchMedia && window.matchMedia('(hover: none)').matches;
      tops.forEach(function (t) {
        var i = t.getAttribute('data-pcn-top');
        t.addEventListener('mouseenter', function () { hydrate(panel(i)); clearTimeout(openT); openT = setTimeout(function () { open(i); }, openIdx === null ? 90 : 0); });
        t.addEventListener('mouseleave', function () { clearTimeout(openT); closeSoon(); });
        t.addEventListener('focus', function () { hydrate(panel(i)); });
        t.addEventListener('click', function (e) {
          /* touch screens: first tap opens the panel, second tap follows the link */
          if ((touchy || e.detail === 0) && openIdx !== i) { e.preventDefault(); open(i); var first = panel(i) && panel(i).querySelector('a'); if (e.detail === 0 && first) first.focus(); }
        });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); open(i); var a = panel(i) && panel(i).querySelector('a'); if (a) a.focus(); }
        });
      });
      root.querySelectorAll('[data-pcn-panel]').forEach(function (p) {
        p.addEventListener('mouseenter', function () { clearTimeout(closeT); });
        p.addEventListener('mouseleave', closeSoon);
      });
      var scrim = root.querySelector('[data-pcn-scrim]');
      if (scrim) scrim.addEventListener('click', close);
      window.addEventListener('scroll', function () { if (openIdx !== null) place(); }, { passive: true });
      window.addEventListener('resize', function () { if (openIdx !== null) place(); });
      document.addEventListener('focusin', function (e) {
        if (openIdx === null) return;
        if (!e.target.closest('[data-pcn-panel]') && !e.target.closest('[data-pcn-top]')) close();
      });

      /* ---------- phone drawer ---------- */
      var drawer = root.querySelector('[data-pcn-drawer]');
      /* daily giveaway card: today's prize and draw time from the Poke-Collect Giveaways app */
      var daily = drawer && drawer.querySelector('[data-pcn-daily]'), dailyEnd = 0, dailyT = null, dailyLoaded = false;
      function dailyTick() {
        if (!daily || !dailyEnd) return;
        var left = dailyEnd - Date.now(), box = daily.querySelector('[data-pcn-daily-time]');
        if (left <= 0) { dailyLoaded = false; loadDaily(); return; }
        var h = Math.floor(left / 36e5), m = Math.floor(left % 36e5 / 6e4), sec = Math.floor(left % 6e4 / 1e3);
        daily.querySelector('[data-pcn-daily-left]').textContent = (h ? h + 'h ' : '') + (m < 10 && h ? '0' : '') + m + 'm ' + (sec < 10 ? '0' : '') + sec + 's';
        box.hidden = false;
      }
      function loadDaily() {
        if (!daily || dailyLoaded) return; dailyLoaded = true;
        var slug = daily.getAttribute('data-slug'); if (!slug) return;
        fetch('/apps/giveaways/' + encodeURIComponent(slug), { headers: { accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (!j || !j.daily) return;
            var p = j.daily.prize || {};
            if (p.title) daily.querySelector('[data-pcn-daily-title]').textContent = p.title;
            var bits = [];
            bits.push('Free to Enter');
            try { bits.push('Winner Drawn at ' + new Date(j.daily.drawAt).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/Chicago' }).replace(':00', '') + ' CT'); } catch (e) {}
            daily.querySelector('[data-pcn-daily-sub]').textContent = bits.join(' · ');
            if (p.imageUrl) {
              var art = daily.querySelector('[data-pcn-daily-art]'), im = new Image(); im.alt = ''; im.decoding = 'async';
              im.src = p.imageUrl + (p.imageUrl.indexOf('?') < 0 ? '?' : '&') + 'width=200';
              art.innerHTML = ''; art.appendChild(im);
            }
            if (j.daily.drawAt) { dailyEnd = new Date(j.daily.drawAt).getTime(); dailyTick(); }
          })
          .catch(function () { dailyLoaded = false; });
      }
      function refreshCartCount() {
        var b = drawer && drawer.querySelector('[data-pcn-cart-count]'); if (!b) return;
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { b.textContent = c.item_count; b.hidden = !c.item_count; }).catch(function () {});
      }
      (function () { var b = drawer && drawer.querySelector('[data-pcn-cart-count]'); if (b && b.textContent.trim() === '0') b.hidden = true; })();
      function openDrawer() {
        if (drawer) { drawer.querySelectorAll('.pcn-ico, .pcn-feature').forEach(hydrate); hydrate(drawer.querySelector('[data-pcn-tiles]')); }
        loadDaily(); clearInterval(dailyT); dailyT = setInterval(dailyTick, 1000); refreshCartCount();
        root.classList.add('is-drawer-open');
        document.documentElement.classList.add('pcn-lock'); body.classList.add('pcn-lock');
        if (burger) burger.setAttribute('aria-expanded', 'true');
        setTimeout(function () { if (drawer) drawer.focus(); }, 50);
      }
      function closeDrawer() {
        if (!root.classList.contains('is-drawer-open')) return;
        root.classList.remove('is-drawer-open'); clearInterval(dailyT);
        document.documentElement.classList.remove('pcn-lock'); body.classList.remove('pcn-lock');
        if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
      }
      if (burger) burger.addEventListener('click', openDrawer);
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-pcn-close]')) { closeDrawer(); return; }
        var btn = e.target.closest('.pcn-dept-btn');
        if (btn && btn.tagName === 'BUTTON') {
          var d = btn.closest('[data-pcn-dept]'), isOpen = d.classList.contains('is-open');
          root.querySelectorAll('[data-pcn-dept].is-open').forEach(function (o) { if (o !== d) { o.classList.remove('is-open'); o.querySelector('.pcn-dept-btn').setAttribute('aria-expanded', 'false'); } });
          if (!isOpen) hydrate(d);
          d.classList.toggle('is-open', !isOpen);
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (!isOpen) setTimeout(function () { d.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 320);
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (openIdx !== null) { var t = tops.filter(function (x) { return x.getAttribute('data-pcn-top') === String(openIdx); })[0]; close(); if (t) t.focus(); }
        closeDrawer();
      });
      window.addEventListener('resize', function () { if (window.innerWidth >= 990) closeDrawer(); else close(); });
    }
    function initAll() { document.querySelectorAll('[data-pcn]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
})();
